import {
    isAudienceChannel,
    isVideoChannel,
} from '../../utils/channels'
import ChannelView from './ChannelView'
import {NavigationComponentProps} from '../../navigation/types'
import React from 'react'
import {navigation} from '../../navigation'
import {useChannels} from '../../hooks/ninchat'

const Channel = (props: NavigationComponentProps<'Channel'>) => {
    const {...rest} = props
    const {channel_id} = navigation.params(rest as NavigationComponentProps<'Channel'>)
    const currentChannel = useChannels([channel_id].filter((id) => Boolean(id)))?.[channel_id] ?? {}

    return (
        <ChannelView
            chat={{channel_id}}
            isAudienceChannel={isAudienceChannel(currentChannel)}
            isVideoChannel={isVideoChannel(currentChannel)}
            queue_id={currentChannel?.channel_attrs?.queue_id}
            realm_id={currentChannel?.realm_id ?? ''}
        />
    )
}

Channel.defaultProps = {embed: false}

export default Channel
